import { Checkbox, TextOrHTML } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { ScrollableText } from "../../../../../../ScrollableText";
import { useQuestionnaire } from "../../../../../../../features/questionnaire";
import type { QuestionComponentProps } from "../../types";
import { QuestionLabel } from "../../../QuestionLabel";
import "./AgreementQuestion.css";

export const AgreementQuestion = ({
  questionFieldProps,
}: QuestionComponentProps) => {
  const { value, onChange, questionLabelProps, helpInfo, ...otherProps } =
    questionFieldProps;

  const { snowplow } = useSnowplowContext();
  const state = useQuestionnaire();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    const agreementValue = isChecked ? "true" : "false";

    snowplow?.trigger("agreementQuestionAnswered", {
      answer: agreementValue,
      selectedCoverages: state.config?.selectedCoverages,
      selectedType: "coverage_selection",
    });

    onChange?.({
      target: {
        name: questionFieldProps.name,
        value: agreementValue,
      },
    });
  };

  // Convert string value to boolean for checkbox
  const isChecked = value === "true" || value === true;

  // Get the agreement text from questionLabelProps
  const agreementText = questionLabelProps?.secondaryText || "";

  return (
    <div className="mobius-agreement-question">
      <QuestionLabel {...questionLabelProps} secondaryText={undefined} />
      {agreementText && (
        <ScrollableText>
          <TextOrHTML
            text={agreementText as string}
            htmlClassName="mobius-agreement-question__text"
          />
        </ScrollableText>
      )}
      <Checkbox
        {...otherProps}
        label="By checking the box I am acknowledging that I have read and agree to each of the above statements"
        selected={isChecked}
        onChange={handleChange}
      />
    </div>
  );
};
